export const COMPOSER_ACTIVATE = 'COMPOSER_ACTIVATE';
export const COMPOSER_ACTIVATE_WITH_STRUCTURE = 'COMPOSER_ACTIVATE_WITH_STRUCTURE';
export const COMPOSER_DEACTIVATE = 'COMPOSER_DEACTIVATE';
export const COMPOSER_SUBMIT = 'COMPOSER_SUBMIT';
export const COMPOSER_SUBMIT_SUCCESS = 'COMPOSER_SUBMIT_SUCCESS';
export const COMPOSER_SUBMIT_ERROR = 'COMPOSER_SUBMIT_ERROR';
export const COMPOSER_SUBMIT_ERROR_DISMISS = 'COMPOSER_SUBMIT_ERROR_DISMISS';
export const COMPOSER_CONTEXT_MENU_ACTIVATE = 'COMPOSER_CONTEXT_MENU_ACTIVATE';
export const COMPOSER_CONTEXT_MENU_DEACTIVATE = 'COMPOSER_CONTEXT_MENU_DEACTIVATE';
export const COMPOSER_RESET = 'COMPOSER_RESET';
export const COMPOSER_STRUCTURE_CHANGE = 'COMPOSER_STRUCTURE_CHANGE';
export const COMPOSER_CONTENT_CHANGE = 'COMPOSER_CONTENT_CHANGE';
export const COMPOSER_COMPANY_CHANGE = 'COMPOSER_COMPANY_CHANGE';
export const COMPOSER_STACK_CHANGE = 'COMPOSER_STACK_CHANGE';
export const COMPOSER_LINK_CHANGE = 'COMPOSER_LINK_CHANGE';
export const COMPOSER_CONTENT_FOCUS = 'COMPOSER_CONTENT_FOCUS';
export const COMPOSER_SUBMIT_NOTICE_DISMISS = 'COMPOSER_SUBMIT_NOTICE_DISMISS';

export const COMPOSER_TOOL_ADD = 'COMPOSER_TOOL_ADD';
export const COMPOSER_TOOL_REMOVE = 'COMPOSER_TOOL_REMOVE';
export const COMPOSER_TOOL_UNSELECT = 'COMPOSER_TOOL_UNSELECT';
export const COMPOSER_TOOL_CHOOSE = 'COMPOSER_TOOL_CHOOSE';

export const COMPOSER_PROMPT_DISMISS = 'COMPOSER_PROMPT_DISMISS';
export const COMPOSER_POST_CHANGE = 'COMPOSER_POST_CHANGE';
